import React from 'react';
const Footer = () => {
  return(
  <p className= "footer">Copyright © 2021 |  Jason M. Vallery</p>
  )
}

export default Footer;